/**
 * MODULE: assistantMarkdownNormalize.ts
 * PURPOSE: Normalize assistant-authored markdown so remark-gfm parses lists and emphasis reliably.
 */

/** Insert blank lines GFM requires before list items that follow section labels. */
export function normalizeAssistantMarkdown(content: string): string {
  let text = (content || '').replace(/\r\n/g, '\n').trim();
  if (!text) return text;

  // GFM lists need a blank line after section headers ending with :
  text = text.replace(/^(\*\*[^*\n]+:\*\*)\n(?=[-*+]|\d+\.)/gm, '$1\n\n');

  // Collapse 3+ consecutive newlines (streaming glitches) to two.
  text = text.replace(/\n{3,}/g, '\n\n');

  return text;
}
